"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Is = exports.is = void 0;
const mol_validator_utils_1 = require("../utils/mol-validator-utils");
async function is(value, args, constraints) {
    const shouldValidate = await (0, mol_validator_utils_1.evaluateBaseConstraints)(value, args, constraints);
    if (!shouldValidate) {
        return { pass: true, skipped: true };
    }
    const allConditionsPassed = await (0, mol_validator_utils_1.evaluateBaseConstraints)(value, args, { if: constraints === null || constraints === void 0 ? void 0 : constraints.condition });
    if (!allConditionsPassed) {
        return { pass: false, message: constraints === null || constraints === void 0 ? void 0 : constraints.message };
    }
    return { pass: true };
}
exports.is = is;
/**
 * Validates that all the conditions were all met
 */
function Is(constraints, options) {
    return (0, mol_validator_utils_1.registerValidatorDecorator)({
        name: "Is",
        defaultMessage: "should meet the condition(s)",
        options,
        constraints,
        validateFn: is,
    });
}
exports.Is = Is;
//# sourceMappingURL=Is.js.map